import script from "./FilterablePopover.vue?vue&type=script&lang=ts&setup=true"
export * from "./FilterablePopover.vue?vue&type=script&lang=ts&setup=true"

import "./FilterablePopover.vue?vue&type=style&index=0&id=888b3184&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-888b3184"]])

export default __exports__